import { Map } from 'immutable';

export const portCoordinatesReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'UPDATE_PORT_CACHE':
      return state.set(action.port, action.coords);
    default:
      return state;
  }
};

export const updatePortCache = (dispatch, port, coords) =>
  dispatch({ type: 'UPDATE_PORT_CACHE', port, coords });
